import React from 'react';
import { FormattedMessage } from 'react-intl';
import {
  Link, IllustratedMessage, Content, Heading,
} from '@adobe/react-spectrum';
import Error from '@spectrum-icons/illustrations/Error';
import GlobalData from '../utils/GlobalData';
import ServiceErrorScreenScss from '../assets/styles/ServiceErrorScreen.module.scss';

export default function ServiceErrorScreen() {
  const forumURL = `https://adobe.com/go/community-jarvis${GlobalData.urlRegion}`;

  const onRefreshClick = (event) => {
    event.preventDefault();
  };

  const refreshLink = (
    // eslint-disable-next-line
    <Link
      href="#"
      UNSAFE_className={ServiceErrorScreenScss.linkClickColour}
      onPress={onRefreshClick}
      variant="secondary"
    >
      {GlobalData.translatedStrings['app.serviceerror.subtitle.refresh']}
    </Link>
  );

  const forumLink = (
    // eslint-disable-next-line
    <Link
      variant="secondary"
    >
      <a
        href={forumURL}
        className={ServiceErrorScreenScss.linkClickColour}
        target="_blank"
        rel="noreferrer"
      >
        {GlobalData.translatedStrings['app.serviceerror.communitysubtitle.adobeforums']}
      </a>
    </Link>
  );

  const regionNumberLink = (
    // eslint-disable-next-line
    <Link
      variant="secondary"
    >
      <a
        href="https://helpx.adobe.com/contact/phone.html"
        className={ServiceErrorScreenScss.linkClickColour}
        target="_blank"
        rel="noreferrer"
      >
        {GlobalData.translatedStrings['app.serviceerror.callsubtitle.regionnumber']}
      </a>
    </Link>
  );

  return (
    <div className={ServiceErrorScreenScss.errorScreen}>
      <div className={ServiceErrorScreenScss.headerContent}>
        <IllustratedMessage>
          <Error />
          <Heading UNSAFE_className={ServiceErrorScreenScss.title}>{GlobalData.translatedStrings['app.serviceerror.title']}</Heading>
          <Content UNSAFE_className={ServiceErrorScreenScss.subTitle}>
            <FormattedMessage id="app.serviceerror.subtitle" values={{ refreshLink }} />
          </Content>
        </IllustratedMessage>
      </div>
      {(GlobalData.language.toLowerCase() !== 'zh_cn') && (
      <div className={ServiceErrorScreenScss.communityContent}>
        <div className={ServiceErrorScreenScss.communitytitle}>
          <FormattedMessage id="app.serviceerror.communitytitle" />
        </div>
        <div className={ServiceErrorScreenScss.communitysubTitle}>
          <FormattedMessage id="app.serviceerror.communitysubtitle" values={{ forumLink }} />
        </div>
      </div>
      )}
      <div className={ServiceErrorScreenScss.callContent}>
        <div className={ServiceErrorScreenScss.calltitle}>
          <FormattedMessage id="app.serviceerror.calltitle" />
        </div>
        <div className={ServiceErrorScreenScss.callsubTitle}>
          <FormattedMessage id="app.serviceerror.callsubtitle" values={{ regionNumberLink }} />
        </div>
      </div>
    </div>
  );
}
